// extracted by mini-css-extract-plugin
module.exports = {"inventoryVerticalLayout":"InventoryNew_inventoryVerticalLayout__1isQk"};